import React from 'react';
import AppProvider from 'components/AppProvider';
import EditTopBar, { TabIndex } from '../EditTopBar';
import { AudienceType, ParentAudienceProps, PublicAudienceProps, School, ScopeConstraints, StaffAudienceProps, StudentAudienceProps } from '../../../../models/FormProps';
import ContentContainer from './ContentContainer';

interface Props {
  username: string;
  logOutUrl: string;
  school: School;
  tabURLs: Array<string>;
  viewableAudience: PublicAudienceProps | StaffAudienceProps | StudentAudienceProps | ParentAudienceProps;
  scopeConstraints: ScopeConstraints | null;
  personalisedFieldsTableUrl: string;
  clearPersonalisedFieldsUrl: string;
  downloadPersonalisedFieldsUrl: string;
  uploadPersonalisedFieldsUrl: string;
  formsUrl: string;
  logUrl: string;
  updateFormUrl: string;
  viewOnly: boolean;
  isHQUser: boolean;
  formHasResponses: boolean;
  version: number;
  getSchoolsUrl: string;
  getStudentRosterUrl: string;
  getStaffRosterUrl: string;
  enableTeachingGroups: boolean;
  userID: string;
  // The audience type the form is pinned to, from whichever source pinned it -
  // its integration, or its template's scope constraint. Absent when neither
  // does, and when the two disagree, since no pin can be honoured then.
  expectedAudience?: AudienceType;
  parentFormLearnMoreUrl?: string;
}

export default function Page(props: Props): React.ReactElement {
  const { tabURLs } = props;

  return (
    <AppProvider>
      <EditTopBar {...props} tab={TabIndex.Audience} setTab={tab => { window.location.href = tabURLs[tab]; }} />
      <ContentContainer {...props} />
    </AppProvider>
  );
}
